module.exports = "<!--视口-->\n<router-outlet></router-outlet>\n<nz-footer class=\"footer\">©2017 澈見網路電視台 All Rights Reserved.</nz-footer>\n"